import React, { Component } from 'react';

class ResetCss extends Component {
    render() {
        return(
            <style dangerouslySetInnerHTML={{__html: `

                #groutCalculatorMainContainer {
                    font-family: "Open Sans", sans-serif;
                    line-height: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-variant: normal;
                    font-size: 16px;
                    color: #6D6D6D;
                    max-width: 1176px;
                    margin: 0 auto;
                    box-sizing: border-box;
                    -webkit-text-size-adjust: 100%;
                    -ms-text-size-adjust: 100%;
                    -ms-overflow-style: scrollbar;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                }
                #groutCalculatorMainContainer *,
                #groutCalculatorMainContainer *::before,
                #groutCalculatorMainContainer *::after {
                    box-sizing: border-box;
                }
                #groutCalculatorMainContainer article,
                #groutCalculatorMainContainer aside,
                #groutCalculatorMainContainer dialog,
                #groutCalculatorMainContainer figcaption,
                #groutCalculatorMainContainer figure,
                #groutCalculatorMainContainer footer,
                #groutCalculatorMainContainer header,
                #groutCalculatorMainContainer hgroup,
                #groutCalculatorMainContainer main,
                #groutCalculatorMainContainer nav,
                #groutCalculatorMainContainer section {
                  display: block;
                }
                #groutCalculatorMainContainer img {
                    display: block;
                    max-width: none;
                }
                #groutCalculatorMainContainer h3 {
                    font-size: 32px;
                    line-height: 40px;
                    color: #3D3D3D;
                    padding: 0 10px;
                    @media screen and (min-width: 768px) {
                        padding: 0;
                    }
                }
                #groutCalculatorMainContainer h3 span,
                #groutCalculatorMainContainer h3 b,
                #groutCalculatorMainContainer h3 strong {
                    color: #2d4691;
                    font-weight: bold;
                }
                #groutCalculatorMainContainer p {
                    margin: 0;
                }
                #groutCalculatorMainContainer input[type=number]::-webkit-inner-spin-button,
                #groutCalculatorMainContainer input[type=number]::-webkit-outer-spin-button {
                  -webkit-appearance: none;
                  margin: 0;
                }
                #groutCalculatorMainContainer input[type=number] {
                    -moz-appearance:textfield;
                }
                `}}
            />
        );
    }
}

export default ResetCss;
